<template>
  <div
    class="lead-flow-action-menu"
    :class="{
      'lead-flow-action-menu--right': alignRight,
      'lead-flow-action-menu--destructive': showTrashIcon
    }"
  >
    <AppButton
      design="new"
      theme="dark"
      class="lead-flow-action-menu__trigger"
      :class="{ 'lead-flow-action-menu__trigger--open': open }"
      type="button"
      :aria-expanded="open ? 'true' : 'false'"
      aria-haspopup="true"
      @click.native="toggle"
    >
      <svg
        v-if="showTrashIcon"
        class="lead-flow-action-menu__trash-icon"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" />
      </svg>
      {{ label }}
      <span aria-hidden="true"></span>
    </AppButton>
    <div v-if="open" class="lead-flow-action-menu__items">
      <button
        v-for="action in actions"
        :key="action.code"
        type="button"
        :class="{ 'lead-flow-action-menu__item--danger': action.tone === 'danger' }"
        @click="select(action)"
      >
        <strong>{{ action.name }}</strong>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadFlowActionMenu',
  props: {
    label: {
      type: String,
      required: true
    },
    actions: {
      type: Array,
      default: () => []
    },
    alignRight: {
      type: Boolean,
      default: false
    },
    showTrashIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    }
  },
  watch: {
    actions() {
      this.open = false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) this.open = false
    },
    select(action) {
      this.open = false
      this.$emit('select', action)
    }
  }
}
</script>

<style scoped>
.lead-flow-action-menu {
  position: relative;
  min-width: 0;
}

.lead-flow-action-menu__trigger {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 14px;
  border: 1px solid #cfd8cf;
  border-radius: 6px;
  background: #fff;
  color: #526264;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.lead-flow-action-menu--destructive .lead-flow-action-menu__trigger {
  border-color: #cbd5e1;
  background: #fff;
  color: #263750;
}

.lead-flow-action-menu--destructive .lead-flow-action-menu__trigger:hover,
.lead-flow-action-menu--destructive .lead-flow-action-menu__trigger:focus-visible,
.lead-flow-action-menu--destructive .lead-flow-action-menu__trigger--open {
  border-color: #94a3b8;
  background: #f8fafc;
}

.lead-flow-action-menu__trigger span {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 0 3px 1px;
  border-right: 1px solid currentColor;
  border-bottom: 1px solid currentColor;
  transform: rotate(45deg);
  transition: transform .15s ease;
}

.lead-flow-action-menu__trash-icon {
  width: 19px;
  height: 19px;
  flex: 0 0 19px;
  color: #d63d4d;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.lead-flow-action-menu__trigger--open span {
  transform: rotate(225deg);
}

.lead-flow-action-menu__items {
  position: absolute;
  z-index: 8;
  top: calc(100% + 5px);
  left: 0;
  display: grid;
  width: min(240px, calc(100vw - 48px));
  box-sizing: border-box;
  padding: 5px;
  border: 1px solid #dfe4dd;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(30, 50, 45, .13);
}

.lead-flow-action-menu--right .lead-flow-action-menu__items {
  right: 0;
  left: auto;
}

.lead-flow-action-menu__items button {
  display: grid;
  gap: 2px;
  padding: 9px 10px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #314345;
  text-align: left;
  cursor: pointer;
}

.lead-flow-action-menu__items button:hover,
.lead-flow-action-menu__items button:focus {
  background: #f1f5f9;
  outline: 0;
}

.lead-flow-action-menu__items strong {
  font-size: 11px;
}

.lead-flow-action-menu__item--danger strong {
  color: #c83243;
}

.lead-flow-action-menu__items .lead-flow-action-menu__item--danger:hover,
.lead-flow-action-menu__items .lead-flow-action-menu__item--danger:focus {
  background: #fff0f2;
}
</style>
